import { useState, useEffect } from 'react'
import Modal from './Modal'
import Text from './Text'
import Button from './Button'
import { Red, DarkRedHover } from '../assets/colors'

function ConfirmationModal({
  title = 'Confirmar',
  yesButtonAction,
  noButtonAction,
  bodyText,
  errorText,
  closedButton = false,
  isShow = false,
  centered = true,
}) {
  const [error, setError] = useState(errorText)

  useEffect(() => {
    setError(errorText)
  }, [errorText])

  const [show, setShow] = useState(isShow)

  useEffect(() => {
    setShow(isShow)
  }, [isShow])

  return (
    <Modal
      title={title}
      show={show}
      closedButton={closedButton}
      centered={centered}
      style={{ zIndex: 1100 }}
      body={(
        <div style={{ margin: '15px' }}>
          <div style={{ textAlign: 'center' }}>
            <Text style={{ fontSize: '14px' }} plainText={bodyText}/>
          </div>
          <div>
            {error && <Text style={{ fontSize: '14px', color: Red }} plainText={error}/>}
          </div>
          <div style={{
            borderTop: '1px solid #C4C4C4',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: '10px',
            paddingTop: '10px',
          }}
          >
            <Button
              text='yes'
              style={{ height: '34px' }}
              onClick={yesButtonAction}
            />
            <Button
              text='no'
              style={{ height: '34px' }}
              color={Red}
              hoverColor={DarkRedHover}
              onClick={noButtonAction}
            />
          </div>
        </div>
              )}
    />
  )
}

export default ConfirmationModal
